function truthyEnv(value) {
	return value === 'true' || value === '1' || value === 'yes';
}

export const DEBUG_PAYMENTS = truthyEnv(process.env.REACT_APP_DEBUG_PAYMENTS);

export function debugPaymentsLog(...args) {
	if (!DEBUG_PAYMENTS) return;
	// eslint-disable-next-line no-console
	console.log(...args);
}

